<div class="general-doc">
    <div>
        <h1>
            Copyright Takedown Policy
        </h1>
    </div>
    <div>
        <p>
            Every reasonable effort will be made on the part of the Research Arsenal to determine any
            copyright restrictions on all material. Infringing materials placed on the website will be
            immediately taken down if they are brought to the attention of the Research Arsenal.
        </p>
        <p>
            If you believe your copyright has been infringed on please contact us at 
            <a href="mailto: support@researcharsenal.com">support&#64;researcharsenal.com</a> and include the following information:
        </p>
        <ol>
            <li>The signature or electronic signature of the copyright owner or an authorized agent;</li>
            <li>Identification of the copyrighted work claimed to have been infringed, or, if multiple works, a representative list of such works;</li>
            <li>Link to the infringing work;</li>
            <li>Contact information for the copyright owner or authorized agent;</li>
            <li>A statement that the person sending the notice has a good faith belief that use of the material
                in the manner complained of is not authorized by the copyright owner, its agent, or the law; and</li>
            <li>A statement that the information in the notice is accurate, and under penalty of perjury, that
                the person sending the notice is authorized to act on behalf of the copyright owner.</li>
        </ol>
    </div>
</div>
